export default __webpack_public_path__ + "static/media/7 Customar Service Department.25fbf268.jpg";